import Vue from 'vue'
import VueCookies from 'vue-cookies'
import VueLocalStorage from 'vue-localstorage'
import VueMeta from 'vue-meta'
import VueMoment from 'vue-moment'
import { sync }  from 'vuex-router-sync'
import BootstrapVue from 'bootstrap-vue'
import router from './router'
import store from './store'
import './components'
import './mixins'

//------------------------------------------------------------

sync(store, router)

//-----------------------------------------------------------

const APP_NAME      = document.head.querySelector('meta[name="application-name"]').content
const APP_VERSION   = document.head.querySelector('meta[name="application-version"]').content
const IS_PRODUCTION = process.env.NODE_ENV !== 'production'

Vue.config.debug         = !IS_PRODUCTION
Vue.config.performance   = !IS_PRODUCTION
Vue.config.productionTip = false
Vue.config.errorHandler  = window.console.error

Vue.use
(
	BootstrapVue,
	{
		BButtonClose:
		{
			content: '',
		},

		BToast:
		{
			toaster: 'b-toaster-bottom-right',

			toastClass: [ 'show' ],
		},

		BFormGroup:
		{
			labelClass: 'form-label',
		},

		BModal:
		{
			headerCloseContent: '',
			footerClass: 'py-2 border-top justify-content-between',
		},

		BTable:
		{
			noSortReset: true,
		},
	}
)

Vue.use(VueCookies)
Vue.use(VueLocalStorage, { bind: true })
Vue.use(VueMeta)
Vue.use(VueMoment)

//------------------------------------------------------------

new Vue
({
	name: 'eCogent',
	el:   '#app',

	router,
	store,

	metaInfo()
	{
		return {
			titleTemplate(value)
			{
				return [ value, APP_NAME ].filter(Boolean).join(' - ')
			}
		}
	},

	beforeCreate()
	{
		window.console.log
		(
			`%c ${APP_NAME} v${APP_VERSION} %c`,
			'background:#0259a1; padding:1px; border-radius:3px; color:#fff',
			'background:transparent'
		)
	},

	render(h)
	{
		return h('router-view')
	},
})